import { GetCurrencyConversionByCodeQuery, useGetCurrencyConversionByCodeQuery } from '@graphql/generated';

/**
 * This is a mock implementation of the currency conversion rates.
 * Base currency: USD
 */
export type CurrencyRateData = Readonly<{
  /** Exchange rate from USD to this currency */
  exchangeRate: number;
  /** Price increase multiplier (e.g., 1.10 = 10% increase, 1.20 = 20% increase) */
  taxesAndFeesMultiplier: number;
  /** Fixed cost per card in minor units */
  fixedCostPerCardInMinorUnits: number;
}>;

export const useCurrencyConversionRate = (currency: string = ''): { data: GetCurrencyConversionByCodeQuery['currencyConversionByCode'] | undefined; loading: boolean } => {
  const { data, loading } = useGetCurrencyConversionByCodeQuery({
    variables: { currencyCode: currency },
    batchMode: 'fast',
    skip: !currency,
  });

  return { data: data?.currencyConversionByCode, loading };
};
